<template>
  <div class="notifications-option">
    <div class="notifications-option__text">
      <p class="notifications-option__title">
        {{ option.title }}
      </p>
      <p class="notifications-option__subtitle">
        {{ option.subtitle }}
      </p>
    </div>
    <ToggleButton
      class="notifications-option__input"
      :value="currentChoice?.includes(option.title) || false"
      type="checkbox"
      @update:value="updateChoices"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { QuestionnaireView } from '@/models/onboarding'
import type {
  NotificationsChoice,
  QuestionnaireNotificationsOption,
} from '@/models/onboarding.types'

import ToggleButton from '@/components/ui/ToggleButton.vue'

const props = defineProps<{
  option: QuestionnaireNotificationsOption
  view: QuestionnaireView
}>()

const currentChoice = computed(() => {
  return props.view.currentChoice as NotificationsChoice
})

function updateChoices(isChecked: boolean): void {
  const newValue = [...currentChoice.value]

  if (isChecked) {
    newValue.push(props.option.title)
  } else {
    const index = newValue.indexOf(props.option.title)
    if (index !== -1) {
      newValue.splice(index, 1)
    }
  }

  props.view.setCurrentChoice(newValue)
}
</script>

<style lang="scss" scoped>
.notifications-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;

  &__title {
    margin-bottom: 2px;
    font-size: 18px;
    line-height: 23px;
    color: $c-black-2;
  }

  &__subtitle {
    font-size: 14px;
    line-height: 20px;
    color: $c-black-6;
  }
}
</style>
